import React from 'react'
import { useGlobalState } from 'state'
import { RainLayer } from 'components/layers/RainLayer'
import { RiverFloodsLayer } from 'components/layers/RiverFloodsLayer'
import { RisklineLayer } from 'components/layers/RisklineLayer'
import { DosyaLayer } from 'components/layers/DosyaLayer'
import { KouzuiLayer } from 'components/layers/KouzuiLayer'

export const TimeSeriesSliderLayers = () => {
  const state = useGlobalState()

  return (
    <>
      { state.app.menu === 'rain' && <RainLayer /> }
      { state.app.menu === 'river-floods' && <RiverFloodsLayer /> }
      { state.app.menu === 'riskline' && <RisklineLayer /> }
      { state.app.menu === 'dosya' && <DosyaLayer /> }
      { state.app.menu === 'kouzui' && <KouzuiLayer /> }
    </>
  )
}
